import { atom } from 'jotai';
import { focusAtom } from 'jotai-optics';

export const uploadsInProgressAtom = atom({
  uploads: [],
});
uploadsInProgressAtom.debugLabel = 'uploadsInProgress';

export const uploadsAtom = focusAtom(uploadsInProgressAtom, (optic) =>
  optic.prop('uploads'),
);

const updateUpload = (currentUploads, filename, generateNewValue) => {
  const currentUpload = currentUploads.find(
    (upload) => upload.filename === filename,
  );
  const currentUploadsWithoutUpdatedOne = currentUploads.filter(
    (upload) => upload.filename !== filename,
  );

  return [...currentUploadsWithoutUpdatedOne, generateNewValue(currentUpload)];
};

const incrementInProgress = (currentUploads, filename) =>
  updateUpload(currentUploads, filename, (currentValue) => {
    const newValue = currentValue;
    newValue.inProgress += 1;
    return newValue;
  });

const incrementComplete = (currentUploads, filename) =>
  updateUpload(currentUploads, filename, (currentValue) => {
    const newValue = currentValue;
    newValue.complete += 1;
    return newValue;
  });

const defaultEmptyUpload = { complete: 0, inProgress: 0, message: '' };
export const addUploadInProgressAtom = atom(
  () => '',
  (get, set, newUpload) => {
    set(uploadsAtom, [
      ...get(uploadsAtom),
      { ...defaultEmptyUpload, ...newUpload },
    ]);
  },
);

export const updateUploadAtom = atom(
  () => '',
  (get, set, newValue) => {
    set(
      uploadsAtom,
      updateUpload(get(uploadsAtom), newValue.filename, (currentValue) => ({
        ...currentValue,
        ...newValue,
      })),
    );
  },
);

export const incrementInProgressAtom = atom(
  () => '',
  (get, set, filename) => {
    set(uploadsAtom, incrementInProgress(get(uploadsAtom), filename));
  },
);
export const incrementCompletedAtom = atom(
  () => '',
  (get, set, filename) => {
    set(uploadsAtom, incrementComplete(get(uploadsAtom), filename));
  },
);

export default { uploadsInProgressAtom };
